import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const DiningTable = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [units, setUnits] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    unitId: 0,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    number: 0,
    chairCount: 0,
    description: "",
    saleUnitId: 0,
    branchId: branchId
  });

  const getGridData = async () => {
    const resp = await apiMethod.getDiningTables(filterModel.branchId, filterModel.unitId, filterModel.size, filterModel.part, filterModel.title);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getAllUnits(filterModel.branchId);
    if (methods.showApiErrors(resp1))
      setUnits(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.number) || formModel.number === 0) {
      errors.push('.شماره میز باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.chairCount) || formModel.chairCount === 0) {
      errors.push('.تعداد صندلی باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.saleUnitId) || formModel.saleUnitId === 0) {
      errors.push('.بخش  باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.number = 0;
    formModel.chairCount = 0;
    formModel.description = "";
    formModel.saleUnitId = 0;
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.unitId = 0;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getDiningTable(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.number = resp.data.number;
    formModel.chairCount = resp.data.chairCount;
    formModel.description = resp.data.description;
    formModel.saleUnitId = resp.data.saleUnitId;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm())
      return false;

    setLoading(true);
    const resp = await apiMethod.createDiningTable(formModel);
    setLoading(false);
    if (!methods.showApiErrors(resp))
      return false;

    setShowFormModal(false);
    getGridData();
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#3`} className='text-start mb-3 link back-link'>
                <span><img src={back} alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#3`} className='link back-link'>
                  <span><img src={back} alt="return" /></span>
                </Link>
                میز‌های غذاخوری
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p> میز‌های غذاخوری
                <a href={`/sale/${branchId}/softwareGuide/#section10`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <label htmlFor="funit" className="form-label">بخش فروش</label>
                    <select
                      id="funit"
                      className="form-select form-select-md"
                      value={filterModel.unitId}
                      onChange={(e) => {
                        filterModel.unitId = e.target.value;
                        setFilterModel({ ...filterModel });
                      }}
                    >
                      <option value={0}>همه‌ی بخش‌ها </option>
                      {units.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='col-12 col-md-5 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-3 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>میز جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                {units.length === 0 ? (
                  <div className='my-5'>
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button className='btn btn-outline-purple' onClick={() => { navigate(`/sale/:branchId/saleunits`) }}>افزودن بخش فروش</button>
                    </div>
                  </div>
                ) :
                  <>
                    <table className="table table-striped table-md " >
                      <thead className='align-middle'>
                        <tr>
                          <th scope="col vertical-center" width="20px">ردیف</th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center">شماره </th>
                          <th scope="col vertical-center">تعداد صندلی </th>
                          <th scope="col vertical-center">بخش</th>
                          <th scope="col vertical-center">توضیحات</th>
                          <th scope="col vertical-center" width="100px">عملیات</th>
                        </tr>
                      </thead>
                      <tbody className='align-middle'>
                        {gridData.map((table, index) => (
                          <tr key={table.id}>
                            <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                            <td>{table.title}</td>
                            <td>{table.number}</td>
                            <td>{table.chairCount}</td>
                            <td>{table.unitTitle}</td>
                            <td>{table.description}</td>
                            <td>
                              <button
                                onClick={() => editItem(table.id)}
                                className='btn btn-sm btn-outline-purple me-2' type='button'>
                                <i className="bi bi-pencil-square"></i>
                              </button>
                              <button
                                onClick={() => selectَItemToDelete(table)}
                                className='btn btn-sm btn-outline-danger' type='button'>
                                <i className="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {filterModel.parts > 1 &&
                      <nav aria-label="Page navigation example" className='mt-5'>
                        <ul className="pagination justify-content-center">
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                              <i className="bi bi-chevron-compact-right"></i>
                            </a>
                          </li>
                          {makePagerItems()}
                          <li className="page-item mx-1">
                            <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                              <i className="bi bi-chevron-compact-left"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    }
                  </>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeDiningTable(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش میز غذاخوری</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title" name="title"
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="number" className="form-label required-label">شماره</label>
                  <input type="text" className="form-control"
                    id="number" name="number"
                    value={formModel.number}
                    onChange={(e) => methods.validateNumberInput(e.target.value) && setFormModel({ ...formModel, number: e.target.value })}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="chairCount" className="form-label required-label">تعداد صندلی</label>
                  <input type="text" className="form-control"
                    id="chairCount" name="chairCount"
                    value={formModel.chairCount}
                    onChange={(e) => methods.validateNumberInput(e.target.value) && setFormModel({ ...formModel, chairCount: e.target.value })}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="unitTitle" className="form-label required-label">بخش</label>
                  <select
                    id="saleUnit"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.saleUnitId}
                    onChange={(e) => {
                      formModel.saleUnitId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>همه‌ی بخش‌ها </option>
                    {units.map((saleUnit) => (
                      <option key={saleUnit.id} value={saleUnit.id}>
                        {saleUnit.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">توضیحات</label>
                  <textarea type="text" className="form-control" id="description" name="description" rows={3}
                    value={formModel.description}
                    onChange={(e) => { setFormModel({ ...formModel, description: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={'میز'}
        />
      }
    </>
  );
}

export default DiningTable;